<ng-template #templateModal let-modal>
    <app-button-modal-close [modal]="modal" modalSize="sm"></app-button-modal-close>
    <div class="modal-body">
        <h1>{{ 'MODALS.TEXT.ATTENTION' | translate }}</h1>

        <p>{{ 'MODALS.TEXT.AGREEMENT' | translate }}</p>

        <div class="btn-group btn-block">
            <button (click)="modal.close()" class="btn btn-success">
                <span>{{ 'MODALS.BUTTONS.AGREE' | translate }}</span>
            </button>
            <button (click)="modal.close()" class="btn btn-danger">
                <span>{{ 'MODALS.BUTTONS.DISAGREE' | translate }}</span>
            </button>
        </div>
    </div>
</ng-template>
<ng-template #templateButtons>
    <div>
        <button (click)="showModal(templateModal)"
                class="btn btn-info gbo_shadow {{styleView === 'vertical' ? 'btn-block' : ''}}"
                style="margin-right: 10px"
        >
            <b>{{ 'CONTRACTS.BUTTONS.CREDIT' | translate }}</b>
        </button>

        <button (click)="showModal(templateModal)"
                class="btn btn-info gbo_shadow {{styleView === 'vertical' ? 'btn-block' : ''}}"
                style="margin-right: 10px">
            <b>{{ 'CONTRACTS.BUTTONS.BANK_GUARANTEE' | translate }}</b>
        </button>

        <button (click)="showModal(templateModal)"
                class="btn btn-info gbo_shadow {{styleView === 'vertical' ? 'btn-block' : ''}}"
                style="margin-right: 10px">
            <b>{{ 'CONTRACTS.BUTTONS.FACTORING' | translate }}</b>
        </button>

        <button (click)="showModal(templateModal)"
                class="btn btn-info gbo_shadow {{styleView === 'vertical' ? 'btn-block' : ''}}"
                style="margin-right: 10px">
            <b>{{ 'CONTRACTS.BUTTONS.LEASING' | translate }}</b>
        </button>
    </div>
</ng-template>


<ng-container *ngIf="styleView === 'vertical'">
    <ng-template [ngTemplateOutlet]="templateButtons"></ng-template>
</ng-container>

<ng-container *ngIf="styleView === 'horizontal'">
    <div class="btn-group">
        <ng-template [ngTemplateOutlet]="templateButtons"></ng-template>
    </div>
</ng-container>

